// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const AccountType = {
  "ADMIN": "ADMIN",
  "MANAGER": "MANAGER",
  "USER": "USER"
};

const LockState = {
  "NOLOCK": "NOLOCK",
  "LOCKED": "LOCKED",
  "UNLOCKED": "UNLOCKED"
};

const SensorType = {
  "FLOOD": "FLOOD",
  "FLOOD_GATE": "FLOOD_GATE",
  "CAMERA": "CAMERA",
  "GENERAL": "GENERAL"
};

const SensorTypeName = {
  "FLOOD": "冠水センサ",
  "FLOOD_GATE": "水門センサ",
  "CAMERA": "カメラ",
  "GENERAL": "汎用センサ"
};


const { User, Sensor, SensorGroup, SensorHistory, SensorChangeHistory, MutateCognitoUserOutput, SendMailOutput, GroupMessage } = initSchema(schema);

export {
  User,
  Sensor,
  SensorGroup,
  SensorHistory,
  SensorChangeHistory,
  AccountType,
  LockState,
  SensorType,
  SensorTypeName,
  MutateCognitoUserOutput,
  SendMailOutput,
  GroupMessage
};